
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ge5Bx6POLkM0b07gk1HW6Ln8nPNFJ6Du_45yh3IQjQh2qsMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexOeQS2i9PmyVKdpEAfLjstHS4B26B6zJZej8Eq8Xp2RUMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchOxjbl7EfFH8wpmXtZsx2wSDuq7OCxqeNVUre5fKUmVgMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexHFH3Nq6cIB6lPDv_7mF21OnKDcjn7_w6zBq8CSXGIkwMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93xMZe8VeJgGLLk4AwKpdNFATJrurvV_WT7XntvRIktmIMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexGRgPhBL5rsneI1sPS3cGoLrZh1WhW6Y_qH2aIJt19LgMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93IsDXDJhuiVMROZm__D0vfr7wK60zg6oDwxLT_Jbi1sQMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexRt7wF4GPyu8vMCEu_VWJHZnhLlBTjavNPtEJxcEpmtoMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_9362Fabvur5EYoObYUEQ2StJDbhB6JjIiyaRe8j0fVuqIMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexY0yW5kRMndDIwwRrF3f5FAQiRTllpgmpp183a3V5nKUMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexhdCpyclYGDwmPNjjepLirtleuketoA8bygXiVvHQV0MMeta } from "/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexGRgPhBL5rsneI1sPS3cGoLrZh1WhW6Y_qH2aIJt19LgMeta || {},
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexRt7wF4GPyu8vMCEu_VWJHZnhLlBTjavNPtEJxcEpmtoMeta || {},
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexY0yW5kRMndDIwwRrF3f5FAQiRTllpgmpp183a3V5nKUMeta || {},
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexhdCpyclYGDwmPNjjepLirtleuketoA8bygXiVvHQV0MMeta || {},
    component: () => import("/codebuild/output/src4268151381/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]